import { Button } from "@/components/ui/button";
import { ListItem } from "./list-item";

import type { House } from "@/types";
import { memo } from "react";

interface Props {
  innerRef: any;
  inView: boolean;
  loading: boolean;
  hasMoreData: boolean;
  properties: House[];
  target?: HTMLAnchorElement["target"];
  cleanSearch: () => void;
}

const Loading = () => (
  <p className="text-base font-semibold w-full text-center mt-8 mb-36">
    Carregando...
  </p>
);

export const List = memo(
  ({
    innerRef,
    inView,
    loading,
    hasMoreData,
    properties,
    target,
    cleanSearch,
  }: Props) => {
    const propertiesLength = properties.length;

    if (!inView && loading) {
      return <Loading />;
    }

    if (propertiesLength > 0) {
      return (
        <>
          <div className={`grid grid-cols-1 sm:grid-cols-3 gap-8 my-10`}>
            {properties.map((estate, index) => (
              <div
                key={estate.id}
                ref={index + 1 === propertiesLength ? innerRef : undefined}
              >
                <ListItem estate={estate} target={target} />
              </div>
            ))}
          </div>
          {inView && hasMoreData ? <Loading /> : null}
        </>
      );
    }

    return (
      <div className="flex flex-col py-10 gap-8">
        <h2 className="text-center">Nenhum leilão encontrado</h2>
        <div className="flex items-center justify-center">
          <Button onClick={cleanSearch}>
            Limpar filtros para ver mais imóveis
          </Button>
        </div>
      </div>
    );
  }
);

List.displayName = "List";
